import {
  WSElement,
  WSGrid,
  WSList,
  WSLoader,
  WSPage,
  WSPageToolbar,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import React from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { useNotifications } from "../../../../query/notifications/queries/useNotifications";
import { useMemberProfile } from "../../../../query/users/queries";
import { WSQueries } from "../../../../query/WSQuery";
import { selectorHasPayerContextUser } from "../../../../shared/selectors/selectorHasPayerContextUser";
import { selectorIsEnterpriseUser } from "../../../../shared/selectors/selectorIsEnterpriseUser";
import { useCustomization } from "../../../customization";
import { AlertsList } from "../../components/AlertsList";
import { TodoList } from "../../components/TodoList";
import { SidePanel } from "./SidePanel";

export const RouteIndex: React.FC = () => {
  const userId = useUserId();

  const queryMember = useMemberProfile(userId);
  const queryTasks = useNotifications({
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
  const { branding } = useCustomization();

  if (!queryMember.data) {
    return <WSLoader.Spinner size="M" m="2XL" />;
  }

  const { name: platformName } = branding(true);
  const isPayerView =
    selectorIsEnterpriseUser(queryMember.data.user) ||
    selectorHasPayerContextUser(queryMember.data.user);
  const names = wsName({
    user: queryMember.data.user,
    member: queryMember.data
  });
  const userName = names.getResolvedName(true);

  return (
    <WSPage>
      <WSPageToolbar title={`Welcome to ${platformName}, ${userName}.`}>
        {isPayerView ? (
          <WSText color="gray500">
            Here are some things you need to do to make sure {userName} is up
            and running with {platformName}.
          </WSText>
        ) : (
          //Here are things you need to do to ensure you’re paid on time.
          <WSText color="gray500">
            Here are things you need to do to ensure you can work with your
            clients.
          </WSText>
        )}
      </WSPageToolbar>

      <WSList gap="2XL">
        <WSGrid gutter="2XL">
          <WSGrid.Item
            span={{
              s: "8"
            }}
          >
            <AlertsList
              key="list"
              showAlerts={queryTasks.isSuccess}
              notifications={queryTasks.data || []}
            />

            <WSElement>
              <WSSectionToolbar title="To-do" mb="L" />
              <WSQueries queries={{ queryTasks }}>
                {({ queryTasksData }) => (
                  <TodoList notifications={queryTasksData} />
                )}
              </WSQueries>
            </WSElement>
          </WSGrid.Item>

          {queryMember.data && !isPayerView ? (
            <WSGrid.Item
              span={{
                s: "4"
              }}
            >
              <SidePanel />
            </WSGrid.Item>
          ) : null}
        </WSGrid>
      </WSList>
    </WSPage>
  );
};
